import React from "react";
import "./App.css";
// import stp1 from "./assets/ro-img/Step 1.png";
// import stp2 from "./assets/ro-img/Step 2.png";
// import stp3 from "./assets/ro-img/Step 3.png";
// import ro5 from "./assets/ro-img/benar ro.png";

import "bootstrap/dist/css/bootstrap.min.css";

import Header from "./Header";
import Footer from "./Footer";
import HomePageProducts from "./HomePageProducts";
// import Apiproducts from "./Apiproducts";
import HeadingNavbar from "./HeadingNavbar";
import HomeTopForm from "./HomeTopForm";
import HomeSlider from "./HomeSlider";

const Home = () => {
  // const Managero = (category) => {
  //   let filterdt = data.filter((item) => item.category == category);
  //   setmngData(filterdt);
  // };

  return (
    <div>
      <HeadingNavbar />
      <Header />
      <HomeSlider />
      <HomePageProducts />
      <HomeTopForm />
      {/* <Apiproducts /> */}

      {/* <section className="how-work-area pb-5 pt-2">
        <div className="container">
          <div className="row">
            <div className="mx-auto col-xl-6 col-lg-7">
              <div className="text-center section-title mb-20">
                <h2>How It Works</h2>
                <p className="text-light">For Customers</p>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="row justify-content-center">
              <div className="col step">
                <h3>Step 1</h3>
              </div>
              <div className="col step">
                <h3>Step 2</h3>
              </div>
              <div className="col step">
                <h3>Step 3</h3>
              </div>
            </div>
            <div className="col-lg-3 col-md-3">
              <div className="single-box">
                <div className="icon">
                  <img src={stp1} alt="img" />
                </div>
                <div className="content">
                  <h2 className="step-responsive">Step 1</h2>
                  <p className="text-light">
                    Search for your best product and book Order
                  </p>
                  <i className="lni lni-arrow-down mobile-only"></i>
                </div>
              </div>
            </div>
            <div className="col-1 align-self-center">
              <div className="arrow col">
                <span className="arrow-text">On the way your product</span>
              </div>
            </div>
            <div className="col-lg-3 col-md-3">
              <div className="single-box">
                <div className="icon">
                  <img src={stp2} alt="img" />
                </div>
                <div className="content">
                  <h2 className="step-responsive">Step 2</h2>
                  <p className="text-light">
                    Agree time and cost with tradespeople for your work
                  </p>
                  <i className="lni lni-arrow-down mobile-only"></i>
                </div>
              </div>
            </div>
            <div className="col-1 align-self-center">
              <div className="arrow col">
                <span className="arrow-text">Happy delivery</span>
              </div>
            </div>
            <div className="col-lg-3 col-md-3">
              <div className="single-box">
                <div className="icon">
                  <img src={stp3} alt="img" />
                </div>
                <div className="content">
                  <h2 className="step-responsive">Step 3</h2>
                  <p className="text-light">
                    Work completed! Leave a review or let us know if you are not
                    happy from the work carried out <br />
                    <span className="fw-bold mt-1">Cash on Delivery</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* <section className="bg-white">
        <div className="container-fluid pt-30 pb-30">
          <div className="row">
            <div className="col-md-12">
              <h2 className="text-center text-dark pb-10">
                Our results in 2022 -2023
              </h2>
              <h6 className="text-center text-orange pb-10">
                Outstanding annual results
              </h6>
              <p className="text-center  mobileview-padding">
                Franchise Hub's low-cost franchise advertising has been helping
                to boost franchise recruitment for franchisors year on year.
              </p>
              <div className="row pt-15 justify-content-center">
                <div className="col-md-2 col-6 text-center">
                  <ul>
                    <li className="text-dark result-heading">418,1</li>
                    <li className="mb-10 text-para fw-500 font-16">
                      <a href="/"> Visitors in 2022-23 </a>
                    </li>
                  </ul>
                </div>
                <div className="col-md-2 col-6 text-center">
                  <ul>
                    <li className="text-dark result-heading">12085</li>
                    <li className="mb-10 text-para fw-500 font-16">
                      {" "}
                      <a href="/">Leads Generated in 2022-23 </a>
                    </li>
                  </ul>
                </div>
                <div className="col-md-2 col-6 text-center">
                  <ul>
                    <li className="text-dark result-heading">2.2m</li>
                    <li className="mb-10 text-para fw-500 font-16">
                      {" "}
                      <a href="/">Page Views in 2022 </a>
                    </li>
                  </ul>
                </div>
                <div className="col-md-2 col-6 text-center">
                  <ul>
                    <li className="text-dark result-heading">278+</li>
                    <li className="mb-10 text-para fw-500 font-16">
                      {" "}
                      <a href="/">wholesaler</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* <section className="mt-35 mb-25">
        <div className="text-center mt-25 mb-25">
          <h2 className=""> Features</h2>
          <p className="d-flex justify-content-center mt-10">
            Makes Water 100% pure through Multiple Purification Process
          </p>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="card card-body1 m-3 ">
                <div>
                  {" "}
                  <img
                    src={ro5}
                    className="img-fluidx tablet-img-size "
                    alt="img"
                  />
                </div>
                <div className="card-bodyx ">
                  <h5 className="card-link clre icone mt-20 ">
                    {" "}
                    Makes Water 100% Pure
                  </h5>
                  <hr className=" border-warning border-3 mwtw opacity-75" />
                  <p className="card-text ">
                    RO Water Purifiers remove bacteria, viruses, chemicals, and
                    even dissolved impurities such as arsenic, rust, pesticides,
                    and fluorides to make water 100% pure and healthy that meets
                    drinking water standards of all model.
                  </p>
                  <a href="/" className="btn btn-dark mt-20 px-5 d-grid">
                    Read More
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="card card-body1 m-3">
                <div>
                  {" "}
                  <img
                    src={ro5}
                    className="img-fluidx tablet-img-size "
                    alt="img"
                  />
                </div>
                <div className="card-bodyx ">
                  <h5 className="card-link clre icone mt-20">
                    Multiple Purification Process
                  </h5>
                  <hr className=" border-warning border-3 mwtw opacity-75" />
                  <p className="card-text">
                    RO purification followed by UV and UF purification removes
                    chemicals, pesticides, fluorides, dissolved impurities,
                    kills bacteria & viruses to make water 100% pure and healthy
                    to drink.
                  </p>
                  <a href="/" className="btn btn-dark mt-20 d-grid">
                    {" "}
                    Read More
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="card card-body1 m-3">
                <div>
                  {" "}
                  <img
                    src={ro5}
                    className="img-fluidx tablet-img-size "
                    alt="img"
                  />
                </div>
                <div className="card-bodyx ">
                  <h5 className="card-link clre  icone mt-20">
                    Removes even Dissolved Impurities
                  </h5>
                  <hr className=" border-warning border-3 mwtw opacity-75" />
                  <p className="card-text">
                    Boiling the water or using conventional purifiers (UV) only
                    kill bacteria and viruses but does not remove dissolved
                    impurities. However, RO Purifiers also remove harmful
                    dissolved impurities besides removing bacteria and viruses.
                  </p>
                  <a href="/" className="btn btn-dark mt-20 d-grid">
                    {" "}
                    Read More
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <Footer />
    </div>
  );
};

export default Home;
